// import suspenseDiaries from "./suspenseDiaries";
// suspenseDiaries is  template for contest page 

import Romance_and_Paranormal_Romance from './RomanceAndParanormalRomance'
import rahasyamay_prem from './RahasyamayPrem'
import Scifiction from './SciFiction'
import {campusDiariesHindi, campusDiaries, campusDiariesTamil, campusDiariesUniversalHindi} from "./CampusDairies"

const chooseContestObject = {
    'romance-and-paranormal-romance' :Romance_and_Paranormal_Romance,
    'rahasyamay-prem' : rahasyamay_prem,
    'sci-fiction' : Scifiction,
    'campus-diaries-hindi': campusDiariesHindi,
    'campus-diaries': campusDiaries,
    'campus-diaries-tamil': campusDiariesTamil,
    'campus-diaries-universal-hindi' : campusDiariesUniversalHindi
}

export {chooseContestObject}
